<template>

  <div
    class="btn-group"
    :class="{'btn-group-lg': size === 'lg', 'btn-group-sm': size === 'sm'}">
    <button
      type="button"
      class="btn text-nowrap"
      :class="{'btn-danger': value === 1, 'btn-light': value !== 1}"
      @click="change(1)">
      <i class="fas fa-thumbs-down" />
      <span v-if="legend">{{ $t('Inappropriate') }}</span>
    </button>
    <button
      type="button"
      class="btn text-nowrap"
      :class="{'btn-warning': value === 2, 'btn-light': value !== 2}"
      @click="change(2)">
      <i class="fas fa-circle" />
      <span v-if="legend">{{ $t('Average') }}</span>
    </button>
    <button
      type="button"
      class="btn text-nowrap"
      :class="{'btn-primary': value === 3, 'btn-light': value !== 3}"
      @click="change(3)">
      <i class="fas fa-thumbs-up" />
      <span v-if="legend">{{ $t('Good') }}</span>
    </button>
    <button
      type="button"
      class="btn text-nowrap"
      :class="{'btn-success': value === 4, 'btn-light': value !== 4}"
      @click="change(4)">
      <i class="fas fa-thumbs-up" />
      <i class="fas fa-thumbs-up" />
      <span v-if="legend">{{ $t('Great') }}</span>
    </button>
  </div>

</template>

<script>
export default {
  name: 'RadioEvaluation',
  props: {
    value: {
      type: Number,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    legend: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    change (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/RadioEvaluation.vue